import config from '../../../config/config';

const isAuthenticated = () => {
    if (localStorage.getItem(config.localStorageKey)) {
        return true;
    }
    return false;
}

export const userService = {
    isAuthenticated,
}